import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=72ee4916&lang=html"
import script from "./chats.vue?vue&type=script&lang=js"
export * from "./chats.vue?vue&type=script&lang=js"
import style0 from "./chats.vue?vue&type=style&index=0&id=72ee4916&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports